/*
  LITS Club (Smile.io) on-site surfaces.

  Adds three quiet entry points to the loyalty program without a floating
  launcher: a header chip, a line under the PDP buy box, and a line in the
  cart drawer. Every trigger is a Smile deep link, so clicking opens the real
  Smile panel with live data. Nothing here talks to the Smile API.

  Smile's own launcher stays switched off in Smile admin. If it is ever turned
  back on it will collide with the Shopify Inbox chat bubble at bottom right.

  NOTE: written as regex-free ES5 on purpose. Shopify auto-minifies .js assets
  and its minifier chokes on regex literals.
*/
(function () {
  'use strict';

  /* Program config, mirrored from Smile admin. Update here if the program changes.
     Read live via the #smile-points-activity-rules deep link.
     5 earned per $1 and 100 = $1 gives a 5% programme. The currency is called
     "Sauce Points" (renamed from LITS Dollars). If any of that changes in
     Smile, update it here too or the site copy will disagree with the panel. */
  var EARN_PER_DOLLAR = 5;     // Sauce Points earned per $1 spent
  var REDEEM_PER_DOLLAR = 100; // Sauce Points needed for $1 off
  var SIGNUP_BONUS = 200;      // Sauce Points for joining

  var LINK_HOME = '#smile-home';
  var LINK_EARN = '#smile-points-activity-rules';

  var CSS = [
    '.lits-club-chip{display:inline-flex;align-items:center;gap:7px;padding:0 14px;height:39px;',
    'background:transparent;box-shadow:inset 0 0 0 2px rgba(17,17,17,.22);color:#111;',
    'font-size:12px;font-weight:800;letter-spacing:.09em;text-transform:uppercase;',
    'text-decoration:none;white-space:nowrap;transition:box-shadow .14s ease,background .14s ease}',
    '.lits-club-chip:hover{background:#FFD100;box-shadow:inset 0 0 0 2px #111;color:#111}',
    '.lits-club-chip .lc-dot{width:9px;height:9px;border-radius:50%;background:#FFD100;',
    'box-shadow:0 0 0 2px rgba(17,17,17,.25);flex:0 0 auto}',
    '@media(max-width:1100px){.lits-club-chip{display:none}}',

    '.lits-club-mob{display:block;padding:14px 0;font-size:16px;font-weight:700;color:inherit;text-decoration:none}',
    '.lits-club-mob small{display:block;font-size:13px;font-weight:500;opacity:.65;margin-top:3px}',

    /* flex order is set inline in buildPdp, not here, because the theme's own
       order rule appears later in the document and would win. */
    '.lits-club-pdp{display:flex;align-items:flex-start;gap:9px;',
    'margin:12px 0 0;padding:12px 0 0;border-top:1px solid rgba(17,17,17,.16)}',
    '.lits-club-pdp .lc-ic{font-size:15px;line-height:1.3;flex:0 0 auto}',
    '.lits-club-pdp p{margin:0;font-size:13.5px;line-height:1.5;color:#111;opacity:.9}',
    '.lits-club-pdp strong{font-weight:800;opacity:1}',
    '.lits-club-pdp a{color:#111;text-decoration:underline;text-underline-offset:2px;font-weight:700}',
    '.lits-club-pdp a:hover{color:#FF3E30}',

    '.lits-club-cd{display:flex;align-items:center;gap:8px;margin:8px 0 2px;padding:9px 0 0;',
    'border-top:1px solid rgba(17,17,17,.14);font-size:13px;line-height:1.4;',
    'color:#111;text-decoration:none;opacity:.92}',
    '.lits-club-cd:hover{opacity:1;color:#111}',
    '.lits-club-cd:hover span{text-decoration:underline;text-underline-offset:2px}',
    '.lits-club-cd .lc-ic{font-size:14px;flex:0 0 auto}',
    '.lits-club-cd strong{font-weight:800}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('lits-club-css')) { return; }
    var s = document.createElement('style');
    s.id = 'lits-club-css';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  /* Pull a number out of a money string without regex. Keeps digits and dots,
     drops currency symbols and thousands separators. */
  function money(text) {
    if (!text) { return 0; }
    var out = '';
    var i;
    for (i = 0; i < text.length; i++) {
      var ch = text.charAt(i);
      if ((ch >= '0' && ch <= '9') || ch === '.') { out += ch; }
    }
    var n = parseFloat(out);
    return isNaN(n) ? 0 : n;
  }

  function fmtInt(n) {
    var s = String(Math.round(n));
    var out = '';
    var count = 0;
    var i;
    for (i = s.length - 1; i >= 0; i--) {
      out = s.charAt(i) + out;
      count++;
      if (count % 3 === 0 && i > 0) { out = ',' + out; }
    }
    return out;
  }

  function pointsFor(amount) { return Math.round(amount * EARN_PER_DOLLAR); }
  function cashFor(points) { return points / REDEEM_PER_DOLLAR; }

  /* ---- header chip -------------------------------------------------- */
  function buildChip() {
    var host = document.querySelector('.nav-cta');
    if (!host || host.querySelector('.lits-club-chip')) { return; }
    var cart = host.querySelector('a.cart');
    var a = document.createElement('a');
    a.className = 'lits-club-chip';
    a.href = LINK_HOME;
    a.setAttribute('aria-label', 'Open the LITS Club rewards panel');
    var dot = document.createElement('span');
    dot.className = 'lc-dot';
    a.appendChild(dot);
    a.appendChild(document.createTextNode('LITS Club'));
    if (cart) { host.insertBefore(a, cart); } else { host.appendChild(a); }
  }

  /* ---- mobile menu entry --------------------------------------------- */
  function buildMobile() {
    var menu = document.getElementById('lits-mobile-menu');
    if (!menu || menu.querySelector('.lits-club-mob')) { return; }
    var anchor = menu.querySelector('.lits-loc-mobile');
    var a = document.createElement('a');
    a.className = 'lits-club-mob';
    a.href = LINK_HOME;
    a.appendChild(document.createTextNode('LITS Club'));
    var small = document.createElement('small');
    small.appendChild(document.createTextNode('Earn on every order. Free to join.'));
    a.appendChild(small);
    if (anchor) { menu.insertBefore(a, anchor); } else { menu.appendChild(a); }
  }

  /* ---- PDP line under the buy box ------------------------------------ */
  function buildPdp() {
    if (document.body.className.indexOf('template-product') === -1) { return; }
    var purchase = document.querySelector('.purchase');
    if (!purchase || purchase.querySelector('.lits-club-pdp')) { return; }
    var form = purchase.querySelector('form.lits-pdp-form');
    if (!form) { return; }

    var meta = document.querySelector('meta[property="og:price:amount"]');
    var price = meta ? money(meta.getAttribute('content')) : 0;
    if (price <= 0) { return; }

    var pts = pointsFor(price);
    var worth = cashFor(pts);

    var box = document.createElement('div');
    box.className = 'lits-club-pdp';
    /* .purchase is a flex container and the theme sets order on its children
       from a <style> block that appears later in the document than our
       injected head CSS, so a stylesheet rule loses the cascade. Inline wins.
       17 matches form.lits-pdp-form, and equal order falls back to DOM
       position, which puts us directly under the add-to-cart button. */
    box.style.order = '17';

    var ic = document.createElement('span');
    ic.className = 'lc-ic';
    ic.appendChild(document.createTextNode('⭐'));
    box.appendChild(ic);

    /* Leads with the signup bonus rather than the per-item earn. At 5 per $1 a
       single bottle only earns about 70 cents, which is a weak hook, whereas
       the 200 joining bonus is worth $2 straight away. */
    var p = document.createElement('p');
    var strong = document.createElement('strong');
    strong.appendChild(document.createTextNode('Join the LITS Club free and get ' + fmtInt(SIGNUP_BONUS) + ' Sauce Points.'));
    p.appendChild(strong);
    p.appendChild(document.createTextNode(
      ' That’s $' + cashFor(SIGNUP_BONUS).toFixed(2) + ' off. This one earns another ' +
      fmtInt(pts) + ' (worth $' + worth.toFixed(2) + '). '));
    var a = document.createElement('a');
    a.href = LINK_EARN;
    a.appendChild(document.createTextNode('How it works'));
    p.appendChild(a);
    box.appendChild(p);

    if (form.nextSibling) {
      purchase.insertBefore(box, form.nextSibling);
    } else {
      purchase.appendChild(box);
    }
  }

  /* ---- cart drawer line ---------------------------------------------- */
  function buildDrawer() {
    var scroll = document.querySelector('.lits-cd-scroll');
    if (!scroll || scroll.querySelector('.lits-club-cd')) { return; }
    var ms = scroll.querySelector('.cd-ms');
    if (!ms) { return; }

    var totalEl = document.querySelector('.lits-cd-foot .cd-foot-row.total span:last-child');
    var total = totalEl ? money(totalEl.textContent) : 0;
    if (total <= 0) { return; }

    var pts = pointsFor(total);

    var a = document.createElement('a');
    a.className = 'lits-club-cd';
    a.href = LINK_EARN;

    var ic = document.createElement('span');
    ic.className = 'lc-ic';
    ic.appendChild(document.createTextNode('⭐'));
    a.appendChild(ic);

    var span = document.createElement('span');
    var strong = document.createElement('strong');
    strong.appendChild(document.createTextNode('This order earns ' + fmtInt(pts) + ' Sauce Points'));
    span.appendChild(strong);
    span.appendChild(document.createTextNode(
      ' ($' + cashFor(pts).toFixed(2) + ' off next time). Join free and get ' +
      fmtInt(SIGNUP_BONUS) + ' more.'));
    a.appendChild(span);

    if (ms.nextSibling) {
      scroll.insertBefore(a, ms.nextSibling);
    } else {
      scroll.appendChild(a);
    }
  }

  /* The drawer re-renders its section HTML on every cart write, which wipes
     anything we injected. Watch it and put the line back. Debounced so a burst
     of mutations only costs one rebuild. */
  var pending = null;
  function scheduleDrawer() {
    if (pending) { clearTimeout(pending); }
    pending = setTimeout(function () {
      pending = null;
      buildDrawer();
    }, 120);
  }

  function watchDrawer() {
    var root = document.querySelector('.lits-cd');
    if (!root || typeof MutationObserver === 'undefined') { return; }
    var obs = new MutationObserver(scheduleDrawer);
    obs.observe(root, { childList: true, subtree: true });
  }

  function build() {
    injectCSS();
    buildChip();
    buildMobile();
    buildPdp();
    buildDrawer();
  }

  function init() {
    build();
    watchDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();